import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { getAPI, reinitialiseAPI } from 'store/apiReducer';
import * as PropTypes from 'prop-types';
import { GroupeBouton, Bouton, Row, Col } from '@design-system-etat/dsfr-react';
import { Link } from 'react-router-dom';
import FeatureFlippingComponent from 'components/FeatureFlipping/FeatureFlippingComponent';
import { FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER } from 'components/FeatureFlipping/featureFlipping.func';
import DataTableDesignEtat from 'components/Commun/Table/DataTableDesignEtat';
import DerouleArmeComponent from 'components/Commun/Arme/DerouleArme/DerouleArmeComponent';
import usagerClientReducer from '../../../../store/usagerReducer';
import RoutesSignalerArmeManquante from '../../armes/signaler-arme-manquante/routes';
import {
    API_GET_DEROULE_ARME_RATELIER,
    API_GET_RECHERCHE_ARMES,
    CONTEXT_GET_RECHERCHE_ARMES,
    CONTEXT_DEROULE_ARME_RATELIER,
    API_GET_FICHE_SITUATION_ARME,
    CONTEXT_FICHE_SITUATION_ARME,
} from '../../../../constants/apiUrls.constants';
import TemplateBoutonsActions from './components/BoutonsActions/TemplateBoutonsActions';
import {
    rechercheStatuts,
    setTableauStatutsArmes,
    statutsArmes,
} from '../../../../components/arme/statuts/StatutsArmes';
import {
    ROLE_HERITIER,
    ROLE_CORRECTION_RATELIER_ARMES,
    DROITS_RATELIER_AJOUTER_UNE_ARME,
    DROITS_RATELIER_MESSAGE_SIGNALER_UNE_ERREUR,
} from '../../../../utils/droitsEtRoles.constant';
import {
    FICHE_SITUATION_PDF,
    MIME_APPLICATION_OCTET_STREAM,
    MIME_APPLICATION_PDF,
} from '../../../../constants/fileConstant';
import VerifierDroitsComponent from '../../../../components/VerifierDroits/VerifierDroitsComponent';
import RoutesDemandeArmeTrouvee from '../../armes/demande-arme-trouvee/routes';
import RoutesDemandeArmeHeritee from '../../armes/demande-arme-heritee/routes';
import { getPath } from '../../../../utils/router';

const Armes = ({
    getApi,
    reinitialiseApi,
    isLoading,
    data,
    isLoadingArme,
    dataProfil,
    isLoadingFicheSituation,
    dataFicheSituation,
}) => {
    const [armesSelectionnees, setArmesSelectionnees] = useState([]);
    const [clearFilters, setClearFilters] = useState(false);

    const rechargerTableau = () => {
        setClearFilters(true);
    };

    const selectionListener = (selectionList) => {
        setArmesSelectionnees([...selectionList]);
    };

    const genererFicheSituation = (uuidArme) => {
        getApi(
            usagerClientReducer,
            API_GET_FICHE_SITUATION_ARME + uuidArme,
            CONTEXT_FICHE_SITUATION_ARME,
        );
    };

    const formaterFicheSituation = () => {
        return {
            action: genererFicheSituation,
            titreFichier: FICHE_SITUATION_PDF,
            mimeType: MIME_APPLICATION_PDF || MIME_APPLICATION_OCTET_STREAM,
            contenu: dataFicheSituation,
            isLoading: isLoadingFicheSituation,
        };
    };

    const rechercheArmes = (params) => {
        let suffixeUrlRecherche = '';
        const queryParameters = {
            ...params,
        };
        Object.entries(queryParameters).forEach((rechercheValue) => {
            if (!rechercheValue[1]) {
                return;
            }
            if (suffixeUrlRecherche === '') {
                suffixeUrlRecherche += '?';
            } else {
                suffixeUrlRecherche += '&';
            }
            if (rechercheValue[0] === 'statutLibelle') {
                suffixeUrlRecherche += rechercheStatuts(rechercheValue);
            } else if (rechercheValue[0] === '_sort' && rechercheValue[1] === 'statutLibelle') {
                suffixeUrlRecherche += `${rechercheValue[0]}=statut`;
            } else {
                suffixeUrlRecherche += `${rechercheValue[0]}=${rechercheValue[1]}`;
            }
        });
        if (clearFilters) {
            setClearFilters(false);
        }

        getApi(
            usagerClientReducer,
            API_GET_RECHERCHE_ARMES + suffixeUrlRecherche,
            CONTEXT_GET_RECHERCHE_ARMES,
        );
    };

    const mockRegimeDetentionTemplate = (row) => {
        if (row.regimeDetention) {
            return row.regimeDetention;
        }

        if (row.classementFrancais.substring(0, 1) === 'C') {
            return 'Déclaration';
        }
        return 'Autorisation';
    };

    const tableauConfig = [
        { field: 'numeroEncodage', header: "Numéro d'encodage", sortable: true, filter: true },
        { field: 'numeroCarcasse', header: 'Numéro de série', sortable: true, filter: true },
        { field: 'type', header: 'Type', sortable: true, filter: true },
        { field: 'marque', header: 'Marque', sortable: true, filter: true },
        { field: 'modele', header: 'Modèle', sortable: true, filter: true },
        { field: 'calibreCanon', header: 'Calibre Canon 1', sortable: true, filter: true },
        { field: 'calibreCanonDeux', header: 'Calibre Canon 2', sortable: true, filter: true },
        { field: 'classementFrancais', header: 'Classement', sortable: true, filter: true },
        {
            field: 'regimeDetention',
            header: 'Régime de détention',
            sortable: false,
            filter: false,
            template: mockRegimeDetentionTemplate,
        },
        {
            field: 'statutLibelle',
            header: 'Statut',
            sortable: true,
            filter: true,
            filterType: 'list',
            filterList: statutsArmes,
        },
        { field: 'expander', header: '', sortable: false, filter: false, expander: true },
    ];

    // Gestion des déroulés
    const {
        isLoading: isLoadingDeroule,
        data: dataDeroule,
        erreur: erreurDeroule,
    } = useSelector((state) => state.armes.recupererDeroule);
    const [informationsDeroule, setInformationsDeroule] = useState({});
    const [erreursDeroule, setErreursDeroule] = useState({});
    const [pileDerouleAObtenir, setPileDerouleAObtenir] = useState([]);

    const getDerouleTemplate = (dataDerouleTemplate) => (row) => {
        const uuidArme = row.uniquid;
        if (erreursDeroule[uuidArme]) {
            return <div>Une erreur est survenue, veuillez réessayer.</div>;
        }

        if (!dataDerouleTemplate[uuidArme] && pileDerouleAObtenir[0] !== uuidArme) {
            // ajout dans la pile si le déroulé n'est pas déjà chargé
            setPileDerouleAObtenir([...pileDerouleAObtenir, uuidArme]);
        }

        return <DerouleArmeComponent data={dataDerouleTemplate[uuidArme]} />;
    };

    // lancer la requête s'il n'y en a pas déjà une en cours, et si il reste des requêtes à faire
    useEffect(() => {
        if (!isLoadingDeroule && pileDerouleAObtenir && pileDerouleAObtenir.length > 0) {
            const uuidArme = pileDerouleAObtenir[0];
            getApi(
                usagerClientReducer,
                API_GET_DEROULE_ARME_RATELIER + uuidArme,
                CONTEXT_DEROULE_ARME_RATELIER,
            );
        }
    }, [pileDerouleAObtenir]);

    useEffect(() => {
        if (dataDeroule) {
            const uuidArme = pileDerouleAObtenir[0];

            if (dataFicheSituation) {
                reinitialiseApi(CONTEXT_FICHE_SITUATION_ARME);
            }
            dataDeroule.ficheSituation = formaterFicheSituation();

            // mettre le resultat de la requête dans le tableau des déroulés
            setInformationsDeroule({ ...informationsDeroule, [uuidArme]: dataDeroule });

            // retirer l'arme de la pile
            pileDerouleAObtenir.shift();
            setPileDerouleAObtenir([...pileDerouleAObtenir]);
        }
    }, [dataDeroule, dataFicheSituation, isLoadingFicheSituation]);

    useEffect(() => {
        if (erreurDeroule) {
            const uuidArme = pileDerouleAObtenir[0];

            // mettre le resultat de la requête dans le tableau des erreurs
            setErreursDeroule({ ...erreursDeroule, [uuidArme]: erreurDeroule });

            // retirer l'arme de la pile
            pileDerouleAObtenir.shift();
            setPileDerouleAObtenir([...pileDerouleAObtenir]);
        }
    }, [erreurDeroule]);

    return (
        <>
            <VerifierDroitsComponent droits={DROITS_RATELIER_MESSAGE_SIGNALER_UNE_ERREUR}>
                <VerifierDroitsComponent droits={[ROLE_CORRECTION_RATELIER_ARMES]}>
                    <Row goutierre>
                        <Col col={12}>
                            <p>
                                Vous trouverez ci-dessous les armes que vous possédez, identifiées
                                par un n° d&apos;encodage. Si les informations sont incorrectes,
                                vous devez utiliser la fonctionnalité &quot;Signaler une
                                erreur&quot; qui apparait lorsque vous cochez une arme. Si des armes
                                sont absentes du râtelier, utilisez la fonctionnalité &quot;Arme
                                absente du râtelier&quot;.
                            </p>
                        </Col>
                        <Col col={12}>
                            <p>
                                Vous disposez de 6 mois pour corriger les informations présentes sur
                                votre râtelier via les deux fonctionnalités précitées. Passé ce
                                délai, les boutons &quot;Signaler une erreur&quot; et &quot;Arme
                                absente du râtelier&quot; ne seront plus accessibles.
                            </p>
                        </Col>
                    </Row>
                </VerifierDroitsComponent>
            </VerifierDroitsComponent>

            {/* lorsque on supprime le feature FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER, on combine le compsant VerifierDroitsComponent avec le précident en ajoutant le role ROLE_HERITIER */}
            <FeatureFlippingComponent
                featureName={FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER}
            >
                <VerifierDroitsComponent droits={[ROLE_HERITIER]}>
                    <VerifierDroitsComponent droits={[ROLE_CORRECTION_RATELIER_ARMES]}>
                        <Row goutierre>
                            <Col col={12}>
                                <p>
                                    Vous trouverez ci-dessous les armes que vous possédez,
                                    identifiées par un n° d&apos;encodage. Si les informations sont
                                    vous devez utiliser la fonctionnalité &quot;Signaler une
                                    erreur&quot; qui apparait lorsque vous cochez une arme. Si des
                                    armes sont absentes du râtelier, utilisez la fonctionnalité
                                    absente du râtelier&quot;.
                                </p>
                            </Col>
                        </Row>
                        <Row goutierre>
                            <Col col={12}>
                                <p>
                                    Vous disposez de 6 mois pour corriger les informations présentes
                                    sur votre râtelier via les deux fonctionnalités précitées. Passé
                                    ce délai, délai, les boutons &quot;Signaler une erreur&quot; et
                                    absente absente du râtelier&quot; ne seront plus accessibles.
                                </p>
                            </Col>
                        </Row>
                    </VerifierDroitsComponent>
                </VerifierDroitsComponent>
            </FeatureFlippingComponent>

            <Row goutierre>
                <Col col={12}>
                    <GroupeBouton alignementHorizontal="right" isHorizontal>
                        <Link to={getPath(RoutesDemandeArmeHeritee)} className="fr-nav">
                            <Bouton niveau="secondaire" label="Arme héritée" />
                        </Link>
                        <Link to={getPath(RoutesDemandeArmeTrouvee)} className="fr-nav">
                            <Bouton niveau="secondaire" label="Arme trouvée" />
                        </Link>
                        <>
                            {dataProfil &&
                                Object.values(dataProfil)[3] &&
                                Object.values(dataProfil)[3].includes(
                                    ROLE_CORRECTION_RATELIER_ARMES,
                                ) && (
                                    <>
                                        <VerifierDroitsComponent
                                            droits={DROITS_RATELIER_AJOUTER_UNE_ARME}
                                        >
                                            <Link
                                                to={getPath(RoutesSignalerArmeManquante)}
                                                className="fr-nav"
                                            >
                                                <Bouton
                                                    niveau="secondaire"
                                                    label="Ajouter une arme"
                                                />
                                            </Link>
                                        </VerifierDroitsComponent>

                                        {/* lorsque on supprime le feature FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER, on combine le compsant VerifierDroitsComponent avec le précident en ajoutant le role ROLE_HERITIER */}
                                        <FeatureFlippingComponent
                                            featureName={
                                                FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER
                                            }
                                        >
                                            <VerifierDroitsComponent droits={[ROLE_HERITIER]}>
                                                <Link
                                                    to={getPath(RoutesSignalerArmeManquante)}
                                                    className="fr-nav"
                                                >
                                                    <Bouton
                                                        niveau="secondaire"
                                                        label="Ajouter une arme"
                                                    />
                                                </Link>
                                            </VerifierDroitsComponent>
                                        </FeatureFlippingComponent>
                                    </>
                                )}
                        </>
                    </GroupeBouton>
                </Col>
            </Row>
            <Row goutierre>
                <Col col={12}>
                    <DataTableDesignEtat
                        columns={tableauConfig}
                        records={
                            data && data.records ? setTableauStatutsArmes(data.records, true) : []
                        }
                        nombreTotal={data && data.nombreTotal}
                        recherche={rechercheArmes}
                        clearFiltersButton
                        clearFiltersForce={clearFilters}
                        isLoading={isLoading || isLoadingArme}
                        areLignesSelectionnables
                        selectionListener={selectionListener}
                        rowExpansionTemplate={getDerouleTemplate(informationsDeroule)}
                        rechercheIcon
                        emptyMessage="Aucun résultat trouvé"
                    />
                </Col>
            </Row>
            {armesSelectionnees && armesSelectionnees.length > 0 && (
                <Row goutierre className="barre-action">
                    <Col col={12}>
                        <TemplateBoutonsActions
                            armesSelectionnees={armesSelectionnees}
                            rechargerTableau={rechargerTableau}
                            rolesProfil={dataProfil ? dataProfil.roles : []}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};

Armes.propTypes = {
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    data: PropTypes.shape({
        nombreTotal: PropTypes.number.isRequired,
        records: PropTypes.array,
    }),
    isLoading: PropTypes.bool,
    isLoadingArme: PropTypes.bool,
    dataProfil: PropTypes.shape({
        roles: PropTypes.array.isRequired,
    }),
    isLoadingFicheSituation: PropTypes.bool,
    dataFicheSituation: PropTypes.string,
};

export default connect(
    (state) => {
        const { data: dataProfil } = state.profil.usager;
        const { isLoading: isLoadingFicheSituation, data: dataFicheSituation } =
            state.armes.ficheSituationArme;
        const { isLoading, data } = state.recherche.armes;
        const { isLoading: isLoadingArme } = state.recherche.armeLoader;
        return {
            isLoading,
            data,
            isLoadingArme,
            dataProfil,
            dataFicheSituation,
            isLoadingFicheSituation,
        };
    },
    {
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(Armes);
